<template>
  <div class="wrapper" role="site">
    <div class="container">
      <div class="grid__content">
          <div class="grid__center-content">
              <div class="row">
                <template v-if="showGrid" >
                  <grid-document
                    :folderId="selectedFolderId"
                    :headers="tableDocuments.headers"
                    :body="tableDocuments.body"
                    :currentPage="currentPageNumber"
                    :totalResult="totalResult"
                    :itemsPerPages="itemsPerPage"
                    @rowSelected="rowSelected"
                    @rowChecked="rowChecked"
                    @rowShiftChecked="rowShiftChecked"
                    @rowUnChecked="rowUnChecked"
                    @applyFilter="applyFilter"
                    @orderBy="orderBy"
                    @pageChanged="pageChanged">
                  </grid-document>
                </template>
                <template v-if="documentInfo">
                  <span>{{gridAlternativeText}}</span>
                </template>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import GridDocument from './documentGridTable'
import * as folderApi from 'api/folderApi.js'
import * as settingsApi from 'api/settingsApi.js'
import documentWindowEventHandler from 'api/documentWindowEventHandler.js'

import mixins from 'mixins'
export default {
  name: 'DocumentGrid',
  components: {
    GridDocument
  },
  mixins: [mixins],
  data () {
    return {
      selectedFolderId: documentWindowEventHandler.currentFolder,
      tableDocuments: {
        tmpHeaders: [],
        headers: [],
        body: []
      },
      showGrid: false,
      documentInfo: false,
      noDocument: false,
      gridAlternativeText: '',
      gridMessage: {
        empty: this.$i18n.t('DocumentGrid.EmptyFolder'),
        error: this.$i18n.t('DocumentGrid.DocumentNotLoaded')
      },
      compact: localStorage.getItem('compact') === 'false',
      currentPageNumber: 1,
      defaultFilters: {
        'Filters': [],
        'Sort': {
          FieldName: '',
          Order: 'asc'
        }
      },
      filtersList: this.defaultFilters,
      itemsPerPage: 100,
      totalResult: 0,
      defaultIcon: 'SpaceIcon',
      newDocument: 'IsNewDocument',
      firstLoad: true,
      viewType: 'projectView'
    }
  },
  methods: {
    setFolderHeaders (data) {
      let headers = []
      let position = 0

      let settingsSortField = localStorage.getItem('gridSortField')
      let settingsSortOrder = localStorage.getItem('gridSortOrder')
      let isOrderSetted = settingsSortField != null && settingsSortOrder != null

      for (let prop in data) {
        let width = 200
        if (data.hasOwnProperty(prop)) {
          if (prop === 'FileType') { continue } // do not show the filetype column

          position += 1
          if (data[prop].Hasfilter === 'True') { width = 15 }

          if (isOrderSetted && data[prop].Caption === settingsSortField) {
            this.filtersList.Sort.FieldName = prop
            this.filtersList.Sort.Order = settingsSortOrder
          }

          headers.push({
            FieldName: prop,
            Hasfilter: data[prop].Hasfilter === 'True',
            Caption: data[prop].Caption,
            width: width,
            Id: position,
            ValueType: data[prop].ValueType
          })
        }
      }
      if (headers.length > 0) {
        this.tableDocuments.tmpHeaders = headers
        return true
      }
      return false
    },
    setFolderData (data) {
      return new Promise((resolve, reject) => {
        try {
          let newDocuments = _.findIndex(data.Documents, x => x.Properties.IsNewDocument !== this.defaultIcon)
          if (newDocuments === -1) {
            _.remove(this.tableDocuments.tmpHeaders, x => x.FieldName === this.newDocument)
          }
          if (this.tableDocuments.tmpHeaders != null) {
            this.tableDocuments.headers = _.cloneDeep(this.tableDocuments.tmpHeaders)
            this.tableDocuments.tmpHeaders = null
          }
          data.Documents.forEach((item, index) => {
            item.index = index
          })
          // get selection state to check Selected files
          this.getCheckedFiles(data.Documents)
          this.tableDocuments.body = data.Documents
          this.viewType = data.ViewType
          this.$store.commit('setStoredViewState', data.ViewType)
          this.totalResult = this.getTotalResult(data)
          this.firstLoad = false
          resolve(data.Documents)
        } catch (e) {
          reject()
        }
      })
    },
    getCheckedFiles (documents) {
      let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
      let selectedDocuments = storageObject.documents
      documents.forEach(item => {
        let idx = _.findIndex(selectedDocuments, x => x === item.Id)
        if (idx !== -1) {
          item.IsSelected = true
        }
      })
    },
    getTotalResult (data) {
      let total = data.TotalRecords
      return total
    },
    isResultFromSearch (data) {
      return !data.IsNewGridCalling
    },
    getDefaultSelectedDocument (data) {
      let selected = data.filter(x => x.IsActive === true)
      if (selected && selected.length > 0) {
        // if there is only one selected then that's the one
        if (selected.length === 1) {
          return selected[0]
        }
        if (selected.length > 1) {
        // if selected length bigger than 1, then these are versions of the same document => deactivate them
        // get the lastDocumentVersionId number
          let maxVersion = Math.max.apply(Math, selected.map(function (v) { return v.Position }))
          let selectedMaxVersion = selected.filter(x => x.Position === maxVersion)
          let minIndex = Math.min.apply(Math, selectedMaxVersion.map(function (v) { return v.index }))
          // deactivate the rest
          let rowSelected = selected[0] // default value for rowSelected
          data.forEach((item) => {
            if (item.IsActive) { // apply only for currently active item
              if (item.Position === maxVersion && item.index === minIndex) {
                rowSelected = item
              } else {
                item.IsActive = false
              }
            }
          })
          return rowSelected
        }
      } else {
        if (data.length > 0) {
          data.forEach((Item) => { Item.IsActive = false })
          data[0].IsActive = true
          return data[0]
        }
      }
      return null
    },
    rowSelected (rowKey, autoClick = false) {
      if (rowKey != null) {
        let self = this
        let row = this.tableDocuments.body.find(x => this.getDocumentKey(x) === rowKey)
        if (row != null) {
          // refresh iframe of documentVersions for the specified documentId
          this.reloadIframe('updateDocumentVersionFrame', row.Id, row.FolderId)
          folderApi.selectDocument(row.Id).then(done => {
            self.updatePropertiesView()
          })
          if (self.reloadFolderTree && !autoClick) {
            self.reloadIframe('updateTreeView', false)
          }
        }
      }
    },
    rowChecked (id) {
      let self = this
      if (id != null) {
        let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
        if (storageObject.documents.indexOf(id) === -1) {
          storageObject.documents.push(id)
        }
        window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
        // Update the cookie
        let date = new Date()
        let storageString = JSON.stringify(storageObject)
        date.setDate(date.getDate() + 1)
        document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
        folderApi.selectDocument(id).then(done => {
          try {
            self.updateSelectedDocumentCount()
          } catch (e) {}
        })
      }
    },
    rowUnChecked (id) {
      let self = this
      let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
      storageObject.documents = storageObject.documents.filter(function (d) { return d !== id })
      window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
      // Update the cookie
      let date = new Date()
      let storageString = JSON.stringify(storageObject)
      date.setDate(date.getDate() + 1)
      document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
      if (id != null) {
        folderApi.selectDocument(id).then(done => {
          try {
            self.updateSelectedDocumentCount()
          } catch (e) {}
        })
      }
    },
    rowShiftChecked (items, addToCheckedDocuments) {
      let self = this
      let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
      if (items.length !== 0) {
        items.forEach(id => {
          if (addToCheckedDocuments) {
            if (storageObject.documents.indexOf(id) === -1) { storageObject.documents.push(id) }
          } else {
            storageObject.documents.splice(storageObject.documents.indexOf(id), 1)
          }
        })
      } else {
        storageObject.documents = []
      }
      window.localStorage.setItem('selectionState', JSON.stringify(storageObject))
      // Update the cookie
      let date = new Date()
      let storageString = JSON.stringify(storageObject)
      date.setDate(date.getDate() + 1)
      document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'
      let docId = this.tableDocuments.body[0]

      folderApi.selectDocument(docId).then(done => {
        try {
          self.updateSelectedDocumentCount()
        } catch (e) {}
      })
    },
    updateSelectedDocumentCount () {
      let _updateCount = () => {
        let selectionState = JSON.parse(window.localStorage.getItem('selectionState'))
        if (selectionState != null && selectionState.documents.length > 0) { return this.$i18n.t('DocumentGrid.selectedDocuments', [selectionState.documents.length]) }
        return ''
      }
      let selectedDocumentElement = window.parent.document.getElementById('selectedDocuments')
      if (selectedDocumentElement != null) {
        selectedDocumentElement.innerText = _updateCount()
      }
    },
    pageChanged ({page, itemsPerPage}) {
      this.$store.commit('setLoadingState')
      this.currentPageNumber = page
      this.itemsPerPage = itemsPerPage
      this.getFolderData(this.selectedFolderId, this.currentPageNumber, this.itemsPerPage, this.filtersList)
    },
    applyFilter (filterList) {
      this.$store.commit('setLoadingState')
      this.filtersList = filterList
      this.currentPageNumber = 1
      this.getFolderData(this.selectedFolderId, this.currentPageNumber, this.itemsPerPage, this.filtersList, true)
      this.$store.commit('applyCriterions')
      this.$eventBus.$emit('applyFilters')
    },
    orderBy (filterList) {
      this.$store.commit('setLoadingState')
      this.filtersList = filterList
      this.currentPageNumber = 1
      this.getFolderData(this.selectedFolderId, this.currentPageNumber, this.itemsPerPage, this.filtersList, true)
      this.$eventBus.$emit('applyFilters', true)
    },
    updatePropertiesView () {
      this.reloadIframe('updatePropertiesViewForDocument')
    },
    updateDocumentVersionsView (documentId, folderId) {
      this.reloadIframe('updateDocumentVersionFrame', folderId, documentId)
    },
    getFolderData (selectedFolderId, currentPageNumber, itemsPerPage, filtersList, fromFilter = false) {
      let self = this
      folderApi.getFolderData(selectedFolderId, currentPageNumber, itemsPerPage, filtersList).then(data => {
        if (data && data.Documents.length < 1) {
          data.Documents = []
          self.setFolderData(data)
          self.documentInfo = false
          self.showGrid = true
          if (!fromFilter) {
            // reload url of version's grid with invalid values to render no versions when folder is empty
            this.reloadIframe('updateDocumentVersionFrame', -1, -1)
            self.updatePropertiesView()
          }
          self.setLoadedState()
        } else {
          self.setFolderData(data).then((documentData) => {
            let selectedDocument = self.getDefaultSelectedDocument(documentData)
            if (selectedDocument != null) {
              self.rowSelected(self.getDocumentKey(selectedDocument), true)
              this.$eventBus.$emit('folderChanged', selectedDocument)
            }
            self.showGrid = true
            self.setLoadedState()
          }).catch(() => {
            self.setGridLoadResult(self, true, false, self.gridMessage.error, true)
          })
        }
      }).catch(() => {
        self.setGridLoadResult(self, true, false, self.gridMessage.error, true)
      })
    },
    loadFolder (folderId, pageNumber, itemsPerPage, filterList) {
      let self = this
      if (folderId >= -1) {
        self.selectedFolderId = folderId
        folderApi.getFolderHeader(folderId).then(headers => {
          if (self.setFolderHeaders(headers)) {
            self.getFolderData(self.selectedFolderId, pageNumber, itemsPerPage, filterList)
          } else {
            self.setGridLoadResult(self, true, false, self.gridMessage.error, true)
          }
        }).catch(() => {
          self.setGridLoadResult(self, true, false, self.gridMessage.error, true)
        })
      } else {
        self.setGridLoadResult(self, true, false, self.gridMessage.empty)
      }
    },
    showGridStatus (self, documentInfo, showGrid, text) {
      self.documentInfo = documentInfo
      self.showGrid = showGrid
      self.gridAlternativeText = text
    },
    setDefaultState (folderId) {
      this.$store.commit('setLoadingState')
      this.tableDocuments.body = []
      if (this.selectedFolderId !== folderId) {
        this.currentPageNumber = 1
      }
      this.firstLoad = true
      this.selectedFolderId = folderId
      this.filtersList = this.defaultFilters
      this.$store.commit('resetCriteriaList')
      this.$eventBus.$emit('resetCriteriaList')
      this.$eventBus.$emit('applyFilters')
    },
    isFolderChanged (self) {
      return (this.viewType === 'projectView' || this.viewType === 'favoriteView') && !(this.selectedFolder === self.$store.getters.getStoredFolderId)
    },
    setLoadedState (failed = null) {
      this.$store.commit('setLoadedState', failed)
      // execute the function notifyFolderLoad of ApplicationForm.js file
      // the function notifyFolderLoad triggers the event to update the folder tree
      this.reloadIframe('notifyFolderLoad')
    },
    setGridLoadResult (self, documentInfo, showGrid, text, result = null) {
      self.showGridStatus(self, documentInfo, showGrid, text)
      self.setLoadedState(result)
    }
  },
  watch: {
    forceFolderLoad () {
      let self = this
      if (this.viewType === self.$store.getters.getStoredView) {
        if (this.isFolderChanged(self)) {
          this.setDefaultState(this.selectedFolder)
        }
      }
      self.$store.commit('setStoredViewState', this.viewType)
      self.$store.commit('setStoredFolderIdState', this.selectedFolder)
      this.loadFolder(this.selectedFolderId, this.currentPageNumber, this.itemsPerPage, this.filtersList)
    }
  },
  computed: {
    selectedFolder () {
      return documentWindowEventHandler.currentFolder
    },
    forceFolderLoad () {
      return documentWindowEventHandler.forceReload
    },
    reloadFolderTree () {
      const viewTypes = ['workboxView', 'filterView', 'newBoxView', 'expectedDocumentsView']
      return viewTypes.includes(this.viewType)
    }
  },
  created () {
    let self = this
    // if (localStorage.getItem('authenticated') === null || localStorage.getItem('authenticated') === 'false') { TODO:Remember activate this
    //   this.$router.push({ name: '/' })
    // }

    try {
      settingsApi.getDocstreamSettings().then(settings => {
        self.$store.commit('setDocstreamSettings', settings)
      }).catch()

      let itemsPerPage = parseInt(localStorage.getItem('ds_items_per_page'))
      if (!isNaN(itemsPerPage)) {
        this.itemsPerPage = itemsPerPage
      }
      self.updateSelectedDocumentCount()
    } catch (e) {}

    if (self.filtersList == null) { self.filtersList = self.defaultFilters }

    this.$store.commit('setLoadingState')
    folderApi.getSelectedFolder().then(folderId => {
      self.loadFolder(folderId, 1, self.itemsPerPage, self.filtersList)
    }).catch(() => {
      self.documentInfo = true
      self.gridAlternativeText = self.gridMessage.error
    })
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/grid/documentGrid.vue